module.exports = __webpack_public_path__ + "media/entities/1205-31ca02fb.png";